import PropTypes from 'prop-types';
import EventModalMediaContent from '../../../../../components/EventModalMediaContent';
import OrderDeliveryStatus from '../../../../order/OrderDeliveryStatus';

const OrderDeliveryDetail = ({ pendingStepFocus }) => (
	<EventModalMediaContent icon='truck' heading='物流'>
		<OrderDeliveryStatus pendingStepFocus={pendingStepFocus} />
	</EventModalMediaContent>
);

OrderDeliveryDetail.propTypes = {
	pendingStepFocus: PropTypes.oneOf(['delivery', 'accept']),
};

export default OrderDeliveryDetail;
